import { useEffect, useState } from "react";
import { api } from "../api.ts";
import { alertasPaciente, normalizarHistoria, type AlertaPaciente } from "../../../dominio/src/index.ts";

const ICONO = (
  <svg viewBox="0 0 16 16" aria-hidden="true"><path d="M8 1.5 15 14H1L8 1.5Z" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" /><path d="M8 6v3.5M8 11.6v.1" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" /></svg>
);

/**
 * Bajo el nombre del paciente: alergias y antecedentes patológicos personales en rojo,
 * antecedentes familiares en amarillo. Se actualiza al guardar la historia o el dictado de la consulta.
 */
export function AlertasPaciente({ pacienteId, alAbrirFicha }: { pacienteId: string; alAbrirFicha: () => void }) {
  const [alertas, setAlertas] = useState<AlertaPaciente[] | null>(null);
  useEffect(() => {
    const cargar = () => api<{ anamnesis: Record<string, unknown>; examen: Record<string, unknown> }>("GET", `/api/pacientes/${pacienteId}/historia`)
      .then((h) => setAlertas(alertasPaciente(normalizarHistoria(h.anamnesis, h.examen).anamnesis))).catch(() => setAlertas(null));
    cargar();
    addEventListener("donna:historia", cargar);
    return () => removeEventListener("donna:historia", cargar);
  }, [pacienteId]);
  if (!alertas?.length) return null;
  return (
    <ul className="alertas-paciente" aria-label="Alertas del paciente">
      {alertas.map((a, i) => (
        <li key={i} className={`alerta-pac ${a.nivel}`}>
          {a.nivel === "pendiente" ? <button type="button" className="enlace-alerta" onClick={alAbrirFicha}>{ICONO}{a.texto}</button> : <>{a.nivel !== "ok" && ICONO}{a.texto}</>}
        </li>
      ))}
    </ul>
  );
}
